import { ROOM_ITEM_LABEL, type RoomItem, type RoomPlan } from '@scs/domain-engine';

/** "Zid 2", "Vodilja 1": numbered in drawing order within its kind. */
export function lineLabel(plan: RoomPlan, lineId: string): string {
  const line = plan.lines.find((l) => l.id === lineId);
  if (!line) return lineId;
  const n = plan.lines.filter((l) => l.kind === line.kind).indexOf(line) + 1;
  return `${line.kind === 'wall' ? 'Zid' : 'Vodilja'} ${n}`;
}

/** Points where walls meet or end, in drawing order ("Ugao 1" …). */
export function wallCorners(plan: RoomPlan): string[] {
  const out: string[] = [];
  for (const l of plan.lines) if (l.kind === 'wall') for (const k of [l.a, l.b]) if (!out.includes(k)) out.push(k);
  return out;
}

export function cornerLabel(plan: RoomPlan, pointId: string): string {
  return `Ugao ${wallCorners(plan).indexOf(pointId) + 1}`;
}

/** "Prozor 1", "Utičnica 3": numbered within its kind over the whole room. */
export function itemLabel(plan: RoomPlan, item: RoomItem): string {
  const n = plan.items.filter((i) => i.kind === item.kind).indexOf(item) + 1;
  return `${ROOM_ITEM_LABEL[item.kind]} ${n}`;
}
